import { render, staticRenderFns } from "./RoomTypeList.vue?vue&type=template&id=4577b2c8"
import script from "./RoomTypeList.vue?vue&type=script&lang=js"
export * from "./RoomTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports